import React, { HTMLAttributes } from 'react';
import { useFormState } from 'react-final-form';

import { FORM_ERROR } from 'final-form';

import Alert from '../Alert';

type IFormErrorProps = HTMLAttributes<HTMLDivElement>;

export const FormError: React.FC<IFormErrorProps> = ({ ...rest }) => {
  const { submitErrors } = useFormState();

  if (!submitErrors || !submitErrors[FORM_ERROR]) {
    return null;
  }

  return (
    <Alert
      data-testid="form-error"
      icon="images/global/icons/16/error.svg"
      iconTitle="Error"
      colorClassName="bg-red-lightest text-red border-red-lighter"
      {...rest}
    >
      {submitErrors[FORM_ERROR]}
    </Alert>
  );
};
